export default __webpack_public_path__ + "static/media/close-gallery.09752a8d.svg";